const initModal = (
	cancelCheckboxesFunction = () => {},
	canSubmitCheckboxesFunction = () => {}
) => {
	const modalToggles = document.querySelectorAll('.modal-toggle')
	const modal = document.querySelector(
		'.modal:not(#flip-modal):not(#reset-modal)'
	)

	// Kein passendes Modal auf der Seite vorhanden
	if (!modal) {
		console.warn('[modal] Kein Standard-Modal gefunden.')
		return
	}

	const cancel = modal.querySelector('.cancel')
	const close = modal.querySelector('.close')
	const submit = modal.querySelector('.submit')
	const modalInner = modal.querySelector('.modal-inner')

	if (cancel) {
		cancel.addEventListener('click', () => {
			modal.classList.add('hidden')
			cancelCheckboxesFunction()
		})
	}

	if (close) {
		close.addEventListener('click', () => {
			modal.classList.add('hidden')
			cancelCheckboxesFunction()
		})
	}

	modal.addEventListener('click', () => {
		modal.classList.add('hidden')
		cancelCheckboxesFunction()
	})

	if (submit) {
		submit.addEventListener('click', () => {
			if (canSubmitCheckboxesFunction() === true) {
				modal.classList.add('hidden')
			}
		})
	}

	if (modalInner) {
		modalInner.addEventListener('click', (e) => {
			e.stopPropagation()
		})
	}
}

export { initModal }